import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Student } from 'src/app/model/student/student.model';
import { StudentHelperService } from '../../service/student-helper.service';
import { StudentHelper2Service } from '../../service/student-helper2.service';

@Component({
    selector: 'view-child-address-info',
    templateUrl: './view-child-address-info.component.html',
    styleUrl: './view-child-address-info.component.scss'
})
export class ViewChildAddressInfoComponent implements OnInit {
    @Input() studentHelperNumber: number = 1;
    student: Student;
    studentId: number;
    partyId: number;
    isEditingPartyContactMechanisms: boolean = false;

    subs: Subscription[] = [];

    constructor(private studentHelperService: StudentHelperService, private studentHelper2Service: StudentHelper2Service) {}

    subscriptions() {
        if (this.studentHelperNumber === 1) {
            let studentSub = this.studentHelperService.student$.subscribe((student) => {
                this.student = student;

                if (this.student.ID) {
                    this.studentId = this.student.ID!;
                    this.partyId = this.student.PERSON.PARTy?.ID!;
                }
            });
            this.subs.push(studentSub);
        } else {
            let studentSub = this.studentHelper2Service.student$.subscribe((student) => {
                this.student = student;

                if (this.student.ID) {
                    this.studentId = this.student.ID!;
                    this.partyId = this.student.PERSON.PARTy?.ID!;
                }
            });
            this.subs.push(studentSub);
        }
    }

    ngOnDestroy(): void {
        this.subs.forEach((sub) => {
            sub.unsubscribe();
        });
    }

    ngOnInit(): void {
        this.subscriptions();
    }
}
